import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// HIS
import { HisSearchResultComponent } from 'hisng';

@Component( {
    selector: 'psv-unit-search-result',
    templateUrl: './unit-search-result.component.html'
} )
export class UnitSearchResultComponent implements OnInit {
    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent: HisSearchResultComponent;

    public showBackButton = false;

    constructor( private route: ActivatedRoute ) {}

    ngOnInit() {
        this.route.queryParams.subscribe( ( queryParams: any ) => {
            this.showBackButton = queryParams.showBackButton ? queryParams.showBackButton === 'true' : this.showBackButton;
        } );
    }

    /* back to person view */
    back() {
        window.history.back();
    }
}
